import React from 'react';
import ReactPlayer from 'react-player';
import { cn } from '@/lib/utils';

interface DMVideoPlayerProps {
  src: string;
  controls?: boolean;
  playing?: boolean;
  loop?: boolean;
  light?: boolean;
  muted?: boolean;
  className?: string;
  onPlay?: () => void;
  onPause?: () => void;
  onEnded?: () => void;
}

export const DMVideoPlayer = ({
  src,
  controls = true,
  playing = false,
  loop = false,
  light = false,
  muted = false,
  className,
  onPlay,
  onPause,
  onEnded,
}: DMVideoPlayerProps) => {
  return (
    <div className={cn('relative w-full h-full', className)}>
      <ReactPlayer
        url={src}
        controls={controls}
        playing={playing}
        loop={loop}
        light={light}
        muted={muted}
        width="100%"
        height="100%"
        style={{ position: 'absolute', top: 0, left: 0 }}
        onPlay={onPlay}
        onPause={onPause}
        onEnded={onEnded}
      />
    </div>
  );
};
